module.exports = __webpack_public_path__ + "img/lens-150-plus-00.2e23f3d3.png";